export default {"src":"/_next/static/media/sb.0c7130a0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};